import { module } from 'angular';
import { GmcInfoNavTabComponent, GmcTabComponent, NavTabsComponent } from './components';
import { GmcTabsComponent } from './gmc-tabs-set.component';
import { gmcTabHeader } from './directives';

export const GmcTabsModule = module('app.shared.components.gmc-tabs', [])
  .component('navTabs', NavTabsComponent)
  .component('gmcInfoNavTabs', GmcInfoNavTabComponent)
  .component('gmcTabSet', GmcTabsComponent)
  .component('gmcTab', GmcTabComponent)
  .directive('gmcTabHeader', gmcTabHeader);



// WEBPACK FOOTER //
// ./app/shared/components/gmc-tabs/gmc-tabs.module.ts